import React from 'react';

/** Cảnh báo đỏ ở hàng chờ KYB khi mã số thuế hoặc CCCD người đại diện nằm trong danh sách đen (spec §4.5). */
const KybBlacklistWarning: React.FC<{ hit?: boolean }> = ({ hit }) =>
  hit ? (
    <div role="alert" className="mt-1 rounded bg-rose-600 px-2 py-1 text-[11px] font-semibold text-white">
      Trùng danh sách đen: mã số thuế hoặc CCCD người đại diện thuộc người đặt đơn đã bị khoá vĩnh viễn. Không duyệt được hồ sơ
      này.
    </div>
  ) : null;

export default KybBlacklistWarning;
